// The daily chat quota's reset time. Product decision 2026-10-30: the quota resets at MIDNIGHT IN ISRAEL
// (Asia/Jerusalem, summer and winter). The server reports that moment as `resets_at` (/usage, every /chat reply) and
// the card counts down to it — whatever the device's time zone. Display only: the limit and the reset are the server's.

const IL = 'Asia/Jerusalem';

// The wall-clock hour / minute / second in Israel at `ms`.
function israelClock(ms) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: IL, hour: '2-digit', minute: '2-digit',
                                                    second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(ms));
  const get = (t) => Number((parts.find((p) => p.type === t) || {}).value || 0);
  return { h: get('hour'), m: get('minute'), s: get('second') };
}

/** The reset moment in ms: the server's resets_at; without one (an older server), the next midnight in Israel. */
export function resetTime(resetsAt, now = Date.now()) {
  const t = resetsAt ? Date.parse(resetsAt) : NaN;
  if (Number.isFinite(t)) return t;
  const { h, m, s } = israelClock(now);
  return now - (now % 1000) + (86400 - (h * 3600 + m * 60 + s)) * 1000;
}

/** HH:MM:SS left until `target` (never negative). */
export function countdownText(target, now = Date.now()) {
  const diff = Math.max(0, target - now);
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
}

/** When it resets, on Israel's clock: "בחצות" at 00:00 (the policy), otherwise "בשעה 02:00" (an older server). */
export function resetLabel(target) {
  const { h, m } = israelClock(target);
  if (h === 0 && m === 0) return 'בחצות';
  return `בשעה ${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
